import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { useAuth } from '../../context/AuthContext';
import {
  ShoppingBag, User, Menu, X, ChevronDown,
  ChevronRight, Star, MapPin
} from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_event-maestro-95/artifacts/hu1fdxw0_Logo%20fe%CC%82te%20-%20show%20e%CC%81ve%CC%80nement%20-2.png';

// ─── MEGA-MENU CONFIG ────────────────────────────────────
const MEGA_MENU = [
  {
    id: 'louer',
    label: 'Louer',
    color: '#5DBCBF',
    columns: [
      {
        title: 'Jeux',
        items: [
          { label: 'Jeux gonflables', href: '/catalogue?categorie_id=cat-jeux-gonflables' },
          { label: 'Jeux en bois géants', href: '/catalogue?categorie_id=cat-jeux-bois' },
          { label: 'Mini golf', href: '/produit/p-jb-002' },
          { label: 'Parcours aventure', href: '/produit/p-jg-002' },
        ]
      },
      {
        title: 'Photo & Animation',
        items: [
          { label: 'Photobooth premium', href: '/produit/p-ph-001' },
          { label: 'Photobooth 360°', href: '/produit/p-ph-002' },
          { label: 'Borne selfie', href: '/produit/p-ph-003' },
          { label: 'Blind test animé', href: '/produit/p-jb-003' },
        ]
      },
      {
        title: 'Ambiance',
        items: [
          { label: 'Son & lumière', href: '/catalogue?categorie_id=cat-son-lumiere' },
          { label: 'Mobilier & barnum', href: '/catalogue?categorie_id=cat-mobilier' },
          { label: 'Boissons & bar', href: '/catalogue?categorie_id=cat-boissons' },
          { label: 'Brasero & cuisson live', href: '/catalogue?categorie_id=cat-brasero' },
        ]
      },
    ],
    featured: { label: 'Tout le catalogue', href: '/catalogue', badge: '73 animations' }
  },
  {
    id: 'food',
    label: 'Animations gourmandes',
    color: '#F4A7B2',
    columns: [
      {
        title: 'Machines gourmandes',
        items: [
          { label: 'Barbe à papa', href: '/produit/p-fd-001' },
          { label: 'Machine popcorn rétro', href: '/produit/p-fd-002' },
          { label: 'Bubble waffle', href: '/produit/p-fd-005' },
          { label: 'Churros chocolat', href: '/produit/p-fd-007' },
        ]
      },
      {
        title: 'Bars & Tables',
        items: [
          { label: 'Bar à bonbons 3m', href: '/produit/p-fd-003' },
          { label: 'Bar à crêpes + crêpier', href: '/produit/p-fd-004' },
          { label: 'Brasero + grillades', href: '/produit/p-br-002' },
          { label: 'Station smoothies', href: '/produit/p-fd-008' },
        ]
      },
    ],
    featured: { label: 'Toutes les animations gourmandes', href: '/animations-gourmandes', badge: 'Bestsellers' }
  },
  {
    id: 'evenements',
    label: 'Nos événements',
    color: '#D4AF37',
    columns: [
      {
        title: 'Événements privés',
        items: [
          { label: '💍 Mariage', href: '/mariage-lot' },
          { label: '🎂 Anniversaire enfant', href: '/anniversaire-enfant-lot' },
          { label: '🎉 Anniversaire adulte', href: '/anniversaires' },
          { label: '🕊 Baptême & communion', href: '/catalogue' },
        ]
      },
      {
        title: 'Pro & Entreprise',
        items: [
          { label: '💼 Entreprise & CE', href: '/animations-entreprise-lot' },
          { label: '🍺 Cocktail & soirée', href: '/packs' },
          { label: '🌿 Garden party', href: '/packs' },
          { label: '📣 Animation commerciale', href: '/packs' },
        ]
      },
    ],
    featured: { label: 'Créer mon événement', href: '/creer-evenement', badge: 'Devis gratuit' }
  },
  {
    id: 'packs',
    label: 'Packs',
    color: '#C58B19',
    columns: [
      {
        title: 'Événements privés',
        items: [
          { label: '💍 Pack Mariage Premium', href: '/packs', suffix: '-10%' },
          { label: '🎂 Pack Anniversaire enfant', href: '/packs', suffix: '-8%' },
          { label: '🎉 Pack Anniversaire adulte', href: '/packs', suffix: '-8%' },
          { label: '🕊 Pack Baptême & communion', href: '/packs', suffix: '-8%' },
        ]
      },
      {
        title: 'Soirées & Pro',
        items: [
          { label: '🍺 Pack Soirée conviviale', href: '/packs', suffix: '-8%' },
          { label: '🌿 Pack Garden party', href: '/packs', suffix: '-10%' },
          { label: '💼 Pack Cocktail entreprise', href: '/packs', suffix: '-12%' },
          { label: '📣 Pack Animation commerciale', href: '/packs', suffix: '-5%' },
        ]
      },
    ],
    featured: { label: 'Tous les packs', href: '/packs', badge: 'Jusqu\'à -12%' }
  },
  {
    id: 'surmesure',
    label: 'Sur-mesure',
    color: '#F9C5D1',
    columns: [
      {
        title: 'Créations',
        items: [
          { label: '🎈 Arche ballons organiques', href: '/fabrication' },
          { label: '🎨 Panneau personnalisé', href: '/fabrication' },
          { label: '✨ Décoration thémée', href: '/fabrication' },
          { label: '📷 Cadre photo personnalisé', href: '/fabrication' },
          { label: '🎡 Création libre', href: '/fabrication' },
        ]
      },
    ],
    featured: { label: 'Vous imaginez, nous fabriquons', href: '/fabrication', badge: 'Devis 48h' }
  },
  {
    id: 'zones',
    label: 'Zones',
    color: '#5DBCBF',
    columns: [
      {
        title: 'Zone principale',
        items: [
          { label: '🏠 Figeac (base)', href: '/animations-figeac' },
          { label: 'Capdenac-Gare', href: '/anniversaire-capdenac-gare' },
          { label: 'Decazeville', href: '/location-materiel-decazeville' },
        ]
      },
      {
        title: 'Zone étendue',
        items: [
          { label: 'Cahors', href: '/location-evenementielle-cahors' },
          { label: 'Saint-Céré', href: '/location-evenementielle-saint-cere' },
          { label: 'Rodez', href: '/location-evenementielle-rodez' },
          { label: 'Aurillac', href: '/location-evenementielle-aurillac' },
        ]
      },
    ],
    featured: { label: 'Zone d\'intervention 1h30', href: '/contact', badge: 'Vérifier ma zone' }
  },
];

// ─── DROPDOWN DESKTOP ────────────────────────────────────
function DropdownMenu({ item, onClose }) {
  return (
    <div
      className="absolute top-full left-0 z-[100] pt-2"
      style={{ minWidth: item.columns.length > 1 ? 560 : 280 }}
    >
      <div style={{
        background: '#FFFFFF',
        borderRadius: 16,
        border: '1px solid var(--border)',
        boxShadow: '0 24px 64px rgba(26,26,46,0.14)',
        overflow: 'hidden',
      }}>
        {/* Colonnes */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${item.columns.length}, 1fr)`,
          gap: 0,
          padding: '20px',
        }}>
          {item.columns.map((col, ci) => (
            <div key={ci} style={{ paddingRight: ci < item.columns.length - 1 ? 20 : 0, borderRight: ci < item.columns.length - 1 ? '1px solid var(--border)' : 'none', paddingLeft: ci > 0 ? 20 : 0 }}>
              <p style={{ fontSize: 11, fontWeight: 700, color: item.color, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 10 }}>
                {col.title}
              </p>
              {col.items.map((link, li) => (
                <Link
                  key={li}
                  to={link.href}
                  onClick={onClose}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '6px 8px',
                    borderRadius: 8,
                    fontSize: 13,
                    color: 'var(--ink)',
                    textDecoration: 'none',
                    transition: 'background 0.15s',
                    marginBottom: 1,
                  }}
                  onMouseEnter={e => e.currentTarget.style.background = 'var(--bg)'}
                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                >
                  <span>{link.label}</span>
                  {link.suffix && (
                    <span style={{ fontSize: 10, fontWeight: 700, color: '#1F9D7A', background: 'rgba(31,157,122,0.1)', borderRadius: 4, padding: '1px 5px' }}>
                      {link.suffix}
                    </span>
                  )}
                </Link>
              ))}
            </div>
          ))}
        </div>

        {/* Featured bottom */}
        {item.featured && (
          <Link
            to={item.featured.href}
            onClick={onClose}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '12px 20px',
              borderTop: '1px solid var(--border)',
              background: `${item.color}08`,
              fontSize: 13,
              fontWeight: 600,
              color: item.color,
              textDecoration: 'none',
              transition: 'background 0.2s',
            }}
            onMouseEnter={e => e.currentTarget.style.background = `${item.color}15`}
            onMouseLeave={e => e.currentTarget.style.background = `${item.color}08`}
          >
            <span>{item.featured.label}</span>
            <span style={{ fontSize: 11, background: item.color, color: '#FFFFFF', borderRadius: 20, padding: '2px 8px' }}>
              {item.featured.badge}
            </span>
          </Link>
        )}
      </div>
    </div>
  );
}

// ─── CONFIG MENU MOBILE (structure enrichie) ────────────────
const MOBILE_SECTIONS = [
  {
    id: 'evenements', emoji: '🎊', label: 'Nos événements', color: '#D4AF37', badge: 'Nos pages dédiées',
    items: [
      { label: '💍 Mariage', href: '/mariage-lot' },
      { label: '🎂 Anniversaire enfant', href: '/anniversaire-enfant-lot' },
      { label: '💼 Entreprise & CE', href: '/animations-entreprise-lot' },
      { label: '🎉 Anniversaire adulte', href: '/anniversaires' },
      { label: '🕊️ Baptême & communion', href: '/catalogue' },
      { label: '🌿 Garden party', href: '/packs' },
    ],
    featured: { label: 'Créer mon événement', href: '/creer-evenement' },
  },
  {
    id: 'louer', emoji: '🎪', label: 'Louer', color: '#5DBCBF', badge: '73 animations',
    items: [
      { label: 'Jeux gonflables', href: '/catalogue?categorie_id=cat-jeux-gonflables' },
      { label: 'Jeux en bois géants', href: '/catalogue?categorie_id=cat-jeux-bois' },
      { label: 'Mini golf', href: '/produit/p-jb-002' },
      { label: 'Photobooth premium', href: '/produit/p-ph-001' },
      { label: 'Borne 360°', href: '/produit/p-ph-002' },
      { label: 'Son & lumière', href: '/catalogue?categorie_id=cat-son-lumiere' },
      { label: 'Mobilier & barnum', href: '/catalogue?categorie_id=cat-mobilier' },
      { label: 'Brasero & cuisson live', href: '/catalogue?categorie_id=cat-brasero' },
    ],
    featured: { label: 'Tout le catalogue', href: '/catalogue' },
  },
  {
    id: 'food', emoji: '🍬', label: 'Animations gourmandes', color: '#F4A7B2',
    items: [
      { label: 'Barbe à papa', href: '/produit/p-fd-001' },
      { label: 'Machine popcorn rétro', href: '/produit/p-fd-002' },
      { label: 'Bar à bonbons 3m', href: '/produit/p-fd-003' },
      { label: 'Bar à crêpes + crêpier', href: '/produit/p-fd-004' },
      { label: 'Churros chocolat', href: '/produit/p-fd-007' },
      { label: 'Station smoothies', href: '/produit/p-fd-008' },
    ],
    featured: { label: 'Toutes les animations gourmandes', href: '/animations-gourmandes' },
  },
  {
    id: 'packs', emoji: '🎁', label: 'Packs événements', color: '#C58B19', badge: 'jusqu\'à -12%',
    items: [
      { label: '💍 Mariage Premium', href: '/packs', suffix: '-10%' },
      { label: '🎂 Anniversaire enfant', href: '/packs', suffix: '-8%' },
      { label: '🥂 Anniversaire adulte', href: '/packs', suffix: '-8%' },
      { label: '💼 Cocktail entreprise', href: '/packs', suffix: '-12%' },
      { label: '🕊️ Baptême & communion', href: '/packs', suffix: '-8%' },
      { label: '🌿 Garden party', href: '/packs', suffix: '-10%' },
    ],
    featured: { label: 'Tous les packs', href: '/packs' },
  },
  {
    id: 'surmesure', emoji: '✨', label: 'Sur-mesure & déco', color: '#F9C5D1',
    items: [
      { label: '🎈 Arche ballons organiques', href: '/fabrication' },
      { label: '🎨 Panneau personnalisé', href: '/fabrication' },
      { label: '✨ Décoration thémée', href: '/fabrication' },
      { label: '📷 Cadre photo personnalisé', href: '/fabrication' },
      { label: '🎡 Création libre', href: '/fabrication' },
    ],
    featured: { label: 'Devis gratuit en 48h', href: '/fabrication' },
  },
  {
    id: 'boutique', emoji: '🛍️', label: 'Boutique', color: '#8B5CF6',
    items: [
      { label: 'Gobelets personnalisés', href: '/boutique' },
      { label: 'Décorations & accessoires', href: '/boutique' },
      { label: 'Packs boutique', href: '/boutique' },
    ],
    featured: { label: 'Toute la boutique', href: '/boutique' },
  },
  {
    id: 'zones', emoji: '📍', label: 'Zones d\'intervention', color: '#1F9D7A',
    items: [
      { label: '🏠 Figeac (base)', href: '/animations-figeac' },
      { label: 'Capdenac-Gare', href: '/anniversaire-capdenac-gare' },
      { label: 'Decazeville', href: '/location-materiel-decazeville' },
      { label: 'Cahors', href: '/location-evenementielle-cahors' },
      { label: 'Rodez', href: '/location-evenementielle-rodez' },
      { label: 'Aurillac', href: '/location-evenementielle-aurillac' },
    ],
    featured: { label: 'Zone 1h30 autour de Figeac', href: '/contact' },
  },
];

// ─── HEADER PRINCIPAL ────────────────────────────────────
export default function Header() {
  const { getItemCount } = useCart();
  const { user, logout } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);
  const [mobileExpanded, setMobileExpanded] = useState(null);
  const navigate = useNavigate();
  const count = getItemCount();
  const headerRef = useRef(null);

  // Fermer au clic extérieur
  useEffect(() => {
    function handleClick(e) {
      if (headerRef.current && !headerRef.current.contains(e.target)) {
        setOpenMenu(null);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <>
    <header
      ref={headerRef}
      data-testid="site-header"
      className="sticky top-0 z-50 nav-public"
    >
      <div className="container-ose">
        {/* ─── BARRE HEADER ─── */}
        <div className="flex items-center h-[72px] lg:h-16 gap-2">

          {/* Logo — plus grand sur mobile */}
          <Link to="/" className="flex-shrink-0 mr-3 lg:mr-4">
            <img
              src={LOGO_URL}
              alt="Show Événement"
              className="h-[52px] lg:h-11 w-auto object-contain"
              style={{ maxWidth: 160 }}
            loading="lazy" />
          </Link>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-0.5 flex-1">
            {MEGA_MENU.map(item => (
              <div
                key={item.id}
                className="relative"
                onMouseEnter={() => setOpenMenu(item.id)}
                onMouseLeave={() => setOpenMenu(null)}
              >
                <button
                  className="flex items-center gap-1 px-3 py-2 rounded-xl text-sm font-medium transition-all"
                  style={{
                    color: openMenu === item.id ? item.color : 'var(--text-muted)',
                    background: openMenu === item.id ? `${item.color}08` : 'transparent',
                  }}
                >
                  {item.label}
                  <ChevronDown
                    size={13}
                    style={{
                      color: item.color,
                      transform: openMenu === item.id ? 'rotate(180deg)' : 'rotate(0)',
                      transition: 'transform 0.2s'
                    }}
                  />
                </button>
                {openMenu === item.id && (
                  <DropdownMenu item={item} onClose={() => setOpenMenu(null)} />
                )}
              </div>
            ))}

            {/* Liens directs desktop */}
            <Link to="/partenaires"
              className="px-3 py-2 rounded-xl text-sm font-medium"
              style={{ color: 'var(--text-muted)' }}
              onMouseEnter={e => e.currentTarget.style.color = 'var(--teal)'}
              onMouseLeave={e => e.currentTarget.style.color = 'var(--text-muted)'}>
              Partenaires
            </Link>
            <Link to="/contact"
              className="px-3 py-2 rounded-xl text-sm font-medium"
              style={{ color: 'var(--text-muted)' }}
              onMouseEnter={e => e.currentTarget.style.color = 'var(--teal)'}
              onMouseLeave={e => e.currentTarget.style.color = 'var(--text-muted)'}>
              Contact
            </Link>

            <Link
              to="/creer-evenement"
              data-testid="header-primary-cta-button"
              className="btn-teal px-4 py-2.5 text-sm font-bold rounded-xl ml-3"
            >
              Créer mon événement
            </Link>
          </nav>

          {/* Right side */}
          <div className="flex items-center gap-1 ml-auto">
            {/* Cart */}
            <Link
              to="/panier"
              className="relative flex items-center justify-center w-11 h-11 lg:w-9 lg:h-9 rounded-xl hover:bg-[var(--teal-mist)] transition-colors"
              style={{ color: 'var(--ink)' }}
            >
              <ShoppingBag size={22} className="lg:hidden" />
              <ShoppingBag size={20} className="hidden lg:block" />
              {count > 0 && (
                <span className="absolute -top-0.5 -right-0.5 w-5 h-5 rounded-full text-xs flex items-center justify-center font-bold"
                  style={{ background: 'var(--teal)', color: '#0B1E20' }}>
                  {count}
                </span>
              )}
            </Link>

            {/* User / Connexion */}
            {user ? (
              <div className="flex items-center gap-1">
                {user.role === 'admin' && (
                  <Link to="/admin" className="hidden sm:block px-2.5 py-1.5 rounded-xl text-xs font-bold"
                    style={{ background: 'var(--teal-mist)', color: 'var(--teal)' }}>Admin</Link>
                )}
                <Link to="/mes-evenements"
                  className="hidden sm:flex items-center gap-1 px-2.5 py-1.5 rounded-xl text-xs font-semibold"
                  style={{ background: 'rgba(212,175,55,0.08)', color: '#C58B19', border: '1px solid rgba(212,175,55,0.2)' }}>
                  🎉 Mes événements
                </Link>
                <Link to="/mon-compte"
                  className="hidden sm:flex items-center gap-1 px-2.5 py-1.5 rounded-xl text-xs font-semibold"
                  style={{ background: 'rgba(31,157,122,0.08)', color: '#1F9D7A', border: '1px solid rgba(31,157,122,0.2)' }}>
                  🎁 Parrainage
                </Link>
                {/* Icône Mon Compte → navigate vers /mon-compte */}
                <Link
                  to="/mon-compte"
                  className="flex items-center justify-center w-11 h-11 lg:w-9 lg:h-9 rounded-xl hover:bg-[var(--teal-mist)] transition-colors"
                  style={{ color: 'var(--text-muted)' }}
                  title="Mon compte"
                  data-testid="mon-compte-btn"
                >
                  <User size={22} className="lg:hidden" />
                  <User size={20} className="hidden lg:block" />
                </Link>
              </div>
            ) : (
              <Link
                to="/connexion"
                className="hidden sm:flex items-center justify-center w-11 h-11 lg:w-9 lg:h-9 rounded-xl hover:bg-[var(--teal-mist)] transition-colors"
                style={{ color: 'var(--text-muted)' }}
              >
                <User size={22} className="lg:hidden" />
                <User size={20} className="hidden lg:block" />
              </Link>
            )}

            {/* Hamburger mobile */}
            <button
              data-testid="mobile-nav-open-button"
              onClick={() => setMobileOpen(!mobileOpen)}
              className="lg:hidden flex items-center justify-center w-11 h-11 rounded-xl transition-colors"
              style={{
                background: mobileOpen ? 'var(--teal-mist)' : 'transparent',
                color: mobileOpen ? 'var(--teal)' : 'var(--ink)',
              }}
            >
              {mobileOpen
                ? <X size={22} strokeWidth={2.5} />
                : <Menu size={22} strokeWidth={2} />}
            </button>
          </div>
        </div>
      </div>
    </header>

    {/* ════════════════════════════════════════════════════════════
        MENU MOBILE — EN DEHORS DU HEADER (backdrop-filter fix)
        position:fixed doit être hors d'un ancêtre backdrop-filter
        ════════════════════════════════════════════════════════════ */}
    {mobileOpen && (
        <>
          {/* Backdrop */}
          <div
            data-testid="mobile-menu-backdrop"
            className="fixed inset-0 lg:hidden"
            style={{
              background: 'rgba(26,26,46,0.52)',
              backdropFilter: 'blur(4px)',
              zIndex: 9990,
              animation: 'fadeInOverlay 0.2s ease',
            }}
            onClick={() => setMobileOpen(false)}
          />

          {/* Panneau principal */}
          <div
            className="fixed top-0 right-0 bottom-0 lg:hidden overflow-y-auto"
            style={{
              width: 'min(88vw, 360px)',
              background: '#FEFAF5',
              zIndex: 9991,
              boxShadow: '-16px 0 56px rgba(26,26,46,0.18)',
              animation: 'slideInRight 0.28s cubic-bezier(0.22, 1, 0.36, 1)',
            }}
          >

            {/* ── Header panneau ── */}
            <div style={{
              padding: '0 20px',
              height: 72,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              borderBottom: '1px solid var(--border)',
              background: '#FFFFFF',
              position: 'sticky',
              top: 0,
              zIndex: 2,
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <img src={LOGO_URL} alt="Show Événement"
                  style={{ height: 48, width: 'auto', objectFit: 'contain' }} loading="lazy" />
                <div>
                  <p style={{ fontSize: 13, fontWeight: 700, color: 'var(--ink)', lineHeight: 1.2 }}>
                    Show Événement
                  </p>
                  <p style={{ fontSize: 10, color: 'var(--teal)', fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase' }}>
                    Lot (46)
                  </p>
                </div>
              </div>
              <button
                onClick={() => setMobileOpen(false)}
                style={{
                  width: 40, height: 40, borderRadius: 12,
                  background: 'var(--bg)', border: '1px solid var(--border)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: 'var(--ink)', cursor: 'pointer',
                }}
              >
                <X size={18} />
              </button>
            </div>

            {/* ── CTAs prioritaires ── */}
            <div style={{ padding: '16px 16px 12px', display: 'flex', flexDirection: 'column', gap: 10 }}>
              <Link
                to="/creer-evenement"
                data-testid="mobile-cta-create"
                onClick={() => setMobileOpen(false)}
                style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                  padding: '14px 20px', borderRadius: 14,
                  background: 'linear-gradient(135deg, #5DBCBF 0%, #0B4B4E 100%)',
                  color: '#FFFFFF', fontSize: 15, fontWeight: 700,
                  textDecoration: 'none',
                  boxShadow: '0 6px 20px rgba(93,188,191,0.35)',
                }}
              >
                <Star size={16} /> Créer mon événement
              </Link>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                <Link
                  to="/guides"
                  onClick={() => setMobileOpen(false)}
                  style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                    padding: '11px 12px', borderRadius: 12,
                    background: 'rgba(212,175,55,0.1)', border: '1.5px solid rgba(212,175,55,0.3)',
                    color: '#C58B19', fontSize: 13, fontWeight: 700,
                    textDecoration: 'none',
                  }}
                >
                  📚 Guides
                </Link>
                <Link
                  to="/mon-organisation"
                  onClick={() => setMobileOpen(false)}
                  style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                    padding: '11px 12px', borderRadius: 12,
                    background: 'rgba(93,188,191,0.1)', border: '1.5px solid rgba(93,188,191,0.3)',
                    color: '#0B4B4E', fontSize: 13, fontWeight: 700,
                    textDecoration: 'none',
                  }}
                >
                  ✨ Mon orga
                </Link>
                <Link
                  to="/mes-evenements"
                  onClick={() => setMobileOpen(false)}
                  style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5,
                    padding: '11px 12px', borderRadius: 12,
                    background: 'rgba(212,175,55,0.1)', border: '1.5px solid rgba(212,175,55,0.25)',
                    color: '#C58B19', fontSize: 13, fontWeight: 600,
                    textDecoration: 'none',
                  }}
                >
                  🎉 Mes événements
                </Link>
                <Link
                  to="/showroom"
                  onClick={() => setMobileOpen(false)}
                  style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                    padding: '11px 12px', borderRadius: 12,
                    background: 'rgba(139,92,246,0.1)', border: '1.5px solid rgba(139,92,246,0.3)',
                    color: '#8B5CF6', fontSize: 13, fontWeight: 700,
                    textDecoration: 'none',
                  }}
                >
                  🎨 Showroom
                </Link>
                <Link
                  to="/plan-de-table"
                  onClick={() => setMobileOpen(false)}
                  style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                    padding: '11px 12px', borderRadius: 12,
                    background: 'rgba(31,157,122,0.1)', border: '1.5px solid rgba(31,157,122,0.3)',
                    color: '#1F9D7A', fontSize: 13, fontWeight: 700,
                    textDecoration: 'none',
                  }}
                >
                  🪑 Plan de table
                </Link>
              </div>
            </div>

            {/* ── Label section ── */}
            <div style={{ padding: '4px 20px 8px' }}>
              <p style={{ fontSize: 10, fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.1em' }}>
                Nos prestations
              </p>
            </div>

            {/* ── Sections repliables ── */}
            <div style={{ padding: '0 12px 8px' }}>
              {MOBILE_SECTIONS.map(section => (
                <div key={section.id} style={{ marginBottom: 4 }}>
                  {/* Bouton section */}
                  <button
                    data-testid={`mobile-section-${section.id}`}
                    onClick={() => setMobileExpanded(mobileExpanded === section.id ? null : section.id)}
                    style={{
                      width: '100%', display: 'flex', alignItems: 'center', gap: 12,
                      padding: '13px 14px', borderRadius: 14, cursor: 'pointer',
                      border: mobileExpanded === section.id ? `1.5px solid ${section.color}30` : '1.5px solid transparent',
                      background: mobileExpanded === section.id ? `${section.color}08` : 'transparent',
                      transition: 'all 0.15s',
                    }}
                  >
                    {/* Icône colorée */}
                    <div style={{
                      width: 38, height: 38, borderRadius: 11, flexShrink: 0,
                      background: `${section.color}15`,
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: 18,
                    }}>
                      {section.emoji}
                    </div>
                    {/* Label */}
                    <div style={{ flex: 1, textAlign: 'left' }}>
                      <p style={{ fontSize: 14, fontWeight: 700, color: 'var(--ink)', lineHeight: 1.3 }}>
                        {section.label}
                      </p>
                      {section.badge && (
                        <p style={{ fontSize: 10, color: section.color, fontWeight: 600, marginTop: 1 }}>
                          {section.badge}
                        </p>
                      )}
                    </div>
                    {/* Chevron */}
                    <ChevronDown
                      size={16}
                      style={{
                        color: section.color, flexShrink: 0,
                        transform: mobileExpanded === section.id ? 'rotate(180deg)' : 'rotate(0)',
                        transition: 'transform 0.2s',
                      }}
                    />
                  </button>

                  {/* Sous-items */}
                  {mobileExpanded === section.id && (
                    <div style={{
                      marginTop: 4, marginLeft: 14, marginRight: 4,
                      background: '#FFFFFF', borderRadius: 12,
                      border: `1px solid ${section.color}20`,
                      overflow: 'hidden',
                      marginBottom: 8,
                    }}>
                      {section.items.map((link, li) => (
                        <Link
                          key={li}
                          to={link.href}
                          onClick={() => { setMobileOpen(false); setMobileExpanded(null); }}
                          style={{
                            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                            padding: '11px 16px',
                            borderBottom: li < section.items.length - 1 ? '1px solid var(--border)' : 'none',
                            fontSize: 13, color: 'var(--ink)', textDecoration: 'none',
                            fontWeight: 500,
                          }}
                        >
                          <span>{link.label}</span>
                          {link.suffix && (
                            <span style={{
                              fontSize: 10, fontWeight: 700, color: '#1F9D7A',
                              background: 'rgba(31,157,122,0.1)', borderRadius: 4,
                              padding: '2px 6px',
                            }}>
                              {link.suffix}
                            </span>
                          )}
                        </Link>
                      ))}
                      {/* Lien featured */}
                      {section.featured && (
                        <Link
                          to={section.featured.href}
                          onClick={() => { setMobileOpen(false); setMobileExpanded(null); }}
                          style={{
                            display: 'flex', alignItems: 'center', gap: 6,
                            padding: '12px 16px',
                            background: `${section.color}08`,
                            borderTop: `1px solid ${section.color}20`,
                            fontSize: 12, fontWeight: 700, color: section.color,
                            textDecoration: 'none',
                          }}
                        >
                          <ChevronRight size={13} /> {section.featured.label}
                        </Link>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* ── Séparateur + liens secondaires ── */}
            <div style={{ margin: '8px 16px 0', borderTop: '1px solid var(--border)', paddingTop: 12 }}>
              <p style={{ fontSize: 10, fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.1em', paddingLeft: 4, marginBottom: 8 }}>
                Plus
              </p>
              {[
                { to: '/partenaires', label: 'Partenaires', emoji: '🤝' },
                { to: '/blog', label: 'Blog & conseils', emoji: '📰' },
                { to: '/contact', label: 'Contact', emoji: '📞' },
                ...(user ? [
                    { to: '/mon-compte', label: 'Mon compte', emoji: '👤' },
                    { to: '/mon-organisation', label: 'Mon organisation', emoji: '📋' },
                    { to: '/connexion', label: 'Se déconnecter', emoji: '👋', action: () => { logout(); navigate('/'); setMobileOpen(false); } }
                  ]
                         : [{ to: '/connexion', label: 'Se connecter', emoji: '👤' }]),
              ].map(l => (
                <Link
                  key={l.to}
                  to={l.action ? '#' : l.to}
                  onClick={(e) => {
                    if (l.action) { e.preventDefault(); l.action(); }
                    else setMobileOpen(false);
                  }}
                  style={{
                    display: 'flex', alignItems: 'center', gap: 12,
                    padding: '11px 12px', borderRadius: 12,
                    fontSize: 13, fontWeight: 600, color: 'var(--ink)',
                    textDecoration: 'none', marginBottom: 2,
                  }}
                >
                  <span style={{ fontSize: 16, width: 24, textAlign: 'center' }}>{l.emoji}</span>
                  {l.label}
                </Link>
              ))}
            </div>

            {/* ── Pied du panneau ── */}
            <div style={{
              margin: '16px 16px 24px',
              padding: '14px 16px', borderRadius: 14,
              background: 'var(--teal-mist)',
              border: '1px solid rgba(93,188,191,0.2)',
            }}>
              <p style={{ fontSize: 11, fontWeight: 700, color: '#0B4B4E', marginBottom: 2 }}>
                📍 Spécialiste Figeac · Lot · Aveyron · Cantal
              </p>
              <p style={{ fontSize: 10, color: 'rgba(11,75,78,0.65)', lineHeight: 1.5 }}>
                ★★★★☆ 4.6 — 9 avis · Lot · Aveyron · Cantal
              </p>
            </div>
          </div>
        </>
      )}
    </>
  );
}
